// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__1n7FQ","alert":"SettungsInbox_alert__2dVAb"};